/*
 * Title: Leaderboard/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Aside, MobileHead, TabHead, Navigation, AllFansContent from components.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import "./index.css";
import Aside from "@components/Aside";
import MobileHead from "@components/Leaderboard/MobileHead";
import TabHead from "@components/Leaderboard/TabHead";
import Navigation from "@components/Leaderboard/Navigation";
import AllFansContent from "@components/Leaderboard/AllFansContent";

type Props = { name: string };
type MyState = {};
class Leaderboard extends React.Component<Props , MyState> {
  state: MyState = {};

  render() {
    return (
      <div className="h-full relative">
        {/* mobile header title & go back imported from components > leaderboard folder */}
        <MobileHead />

        {/* container  */}
        <div className="container mx-auto mt-10">
          {/* grid columns */}
          <div className="lg:grid lg:grid-cols-3 lg:gap-4">
            {/* desktop points component */}
            <Aside />

            <div className="lg:col-span-2">
              {/* desktop tab header component imported from components > leaderboard folder  */}
              <TabHead />

              {/* Tabs  */}
              <div className="w-full mt-5">
                {/* leaderboard tabs page navigation  */}
                <Navigation />
                {/* All fans content component imported from components > leaderboard */}

                <AllFansContent />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default Leaderboard;